import axios from "axios";
import Cookies from "js-cookie";

let tveApiBaseUrl = window.app_data.appcmsPlatform.tveSettings.urlScheme
const adobeVersion = window?.app_data?.appcmsPlatform?.tveSettings?.version || "v1"
let software_statement = adobeVersion == "v1" ? window.app_data.appcmsPlatform.tveSettings.softwareStatement : window.app_data.appcmsPlatform.tveSettings.softwareStatementV2

const xDeviceInfo = {
  "osName": "web",
  "version": navigator.appVersion,
  "model": navigator.userAgent || "",  
  "os": navigator.platform || "",  
  "browser": navigator.userAgent || ""  
};

const stringfyXDeviceInfo = btoa(JSON.stringify(xDeviceInfo))

const registerDevice= ()=>{
    const URL = `${tveApiBaseUrl}/o/client/register`;
    return axios({
      method: 'post',
      url: URL,
      headers:{
        "Content-Type": "application/json",
        'X-Device-Info': stringfyXDeviceInfo
      },
      data:{
        "software_statement":software_statement
      }
    })
}

const getTokenForDevice = ({grant_types,client_id,client_secret}) => {
    const URL = `${tveApiBaseUrl}/o/client/token`;
     return axios({
      method: 'post',
      url: URL,
      headers:{
        "Content-Type": "application/x-www-form-urlencoded",
        'X-Device-Info': stringfyXDeviceInfo
      },
     data:{
        grant_type:grant_types[0],
        client_id,
        client_secret
     }
    })
    .then((token) => {
        Cookies.set('Tve_Access_token',token.data.access_token)
        return true
    })
}

export {registerDevice,getTokenForDevice}